import { FC } from 'react';
import { Form, Select} from 'antd';
import {CountryDropdownContainerProps} from './country-dropdown-container';
import { Country } from '../../../types/country';

export const CountryDropdown: FC<CountryDropdownContainerProps> = (props) => {
  const handleOnChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <>
      {props.isCitizenship ? (
        <Select
          placeholder={props.placeholder}
          style={props.style}
          showSearch={props.showSearch}
          optionFilterProp={props.optionFilterProp}
          labelRender={props.labelRender}
          onChange={props.onChange}
          {...props} // Pass additional props to the Select component
        >
          {(props.countryData || [])
            .filter((c) => !props.selectedCitizenship?.includes(c.countryCode))
            .map((item) => (
              <Select.Option key={item.countryCode} value={item.countryCode}>
                {item.countryName}
              </Select.Option>
            ))}
        </Select>
      ) : props.isPrimaryEducation ? (
        <Select style={props.style} placeholder="Country" onChange={props.onChange} showSearch optionFilterProp="children">
          {props.allCountryData?.map((item: Country) => (
            <Select.Option key={item.countryCode} value={item.countryCode}>
              {item.countryName}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <Form.Item name={props.name} label={props.label ?? 'Country'} rules={props.rules ?? []}>
          <Select style={props.style} placeholder="Country" onChange={(value) => handleOnChange(value)} showSearch optionFilterProp="children">
            {props.allCountryData?.map((item: Country) => (
              <Select.Option key={item.countryCode} value={item.countryCode}>
                {item.countryName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}
    </>
  );
};
